// We keep the type for the enum in a separate file so that we can import it
// into both client and server code.

export type EnumObjectValues<T> = T[keyof T]
export type EnumObjectKeys<T> = Extract<keyof T, string>

export const RoleEnum = {
  USER: 'user',
  ADMIN: 'admin',
} as const
export type RoleType = EnumObjectValues<typeof RoleEnum>
export type RoleKeysType = EnumObjectKeys<typeof RoleEnum>

export const TruckLoadOccupancyEnum = {
  FTL: 'FTL',
  LTL: 'LTL',
} as const
export type TruckLoadOccupancyType = EnumObjectValues<
  typeof TruckLoadOccupancyEnum
>
export type TruckLoadOccupancyKeysType = EnumObjectKeys<
  typeof TruckLoadOccupancyEnum
>

export const TruckLoadOccupancyEnumAir = {
  AMA: 'AMA',
  AKH: 'AKH',
  'AAP/AA2': 'AAP/AA2',
  AMP: 'AMP',
  AKN: 'AKN',
  AKE: 'AKE',
} as const

export type TruckLoadOccupancyTypeAir = EnumObjectValues<
  typeof TruckLoadOccupancyEnumAir
>
export type TruckLoadOccupancyKeysTypeAir = EnumObjectKeys<
  typeof TruckLoadOccupancyEnumAir
>

export const TruckLoadOccupancyEnumSea = {
  LCL: 'LCL',
  FCL20: `FCL 20'`,
  FCL40: `FCL 40'`,
  FCL40HC: `FCL 40' HC`,
} as const
export type TruckLoadOccupancyTypeSea = EnumObjectValues<
  typeof TruckLoadOccupancyEnumSea
>
export type TruckLoadOccupancyKeysTypeSea = EnumObjectKeys<
  typeof TruckLoadOccupancyEnumSea
>

export const StatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  PENDING: 'pending',
  ALL: 'all',
} as const
export type StatusType = EnumObjectValues<typeof StatusEnum>
export type StatusKeysType = EnumObjectKeys<typeof StatusEnum>

export const TransportTypeEnum = {
  AIR: 'air',
  SEA: 'sea',
  LAND: 'land',
} as const
export type TransportType = EnumObjectValues<typeof TransportTypeEnum>
export type TransportKeysType = EnumObjectKeys<typeof TransportTypeEnum>

export const TransportTypeEnumSpanish = {
  air: 'Aéreo',
  sea: 'Maritimo',
  land: 'Terrestre',
} as const
export type TransportTypeSpanish = EnumObjectValues<
  typeof TransportTypeEnumSpanish
>
export type TransportTypeSpanishKeysType = EnumObjectKeys<
  typeof TransportTypeEnumSpanish
>

export const OfferInvoiceEnum = {
  'PROOF-OF-DELIVERY': 'proofOfDeliveryS3Key',
  'INVOICE-KEY': 'invoiceS3Key',
} as const
export type OfferInvoiceType = EnumObjectValues<typeof OfferInvoiceEnum>
export type OfferInvoiceKeysType = EnumObjectKeys<typeof OfferInvoiceEnum>

export const OffersEnum = {
  ACCEPTED: 'accepted',
  'NO-OFFERS': 'no-offers',
  'NOT-ACCEPTED': 'not-accepted',
  ALL: 'all',
} as const

export const ShipmentAcceptanceEnum = {
  ACCEPTED: 'accepted',
  'NOT-APPLIED': 'not-applied',
  APPLIED: 'applied',
  ALL: 'all',
} as const
export type ShipmentAcceptanceType = EnumObjectValues<
  typeof ShipmentAcceptanceEnum
>

export const OffersVisibilityEnum = {
  SEEN: 'seen',
  UNSEEN: 'unseen',
  ALL: 'all',
} as const

export const IaTaskStatusEnum = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  // TODO: add error status
} as const
export type IaTaskStatusType = EnumObjectValues<typeof IaTaskStatusEnum>
export type IaTaskStatusKeysType = EnumObjectKeys<typeof IaTaskStatusEnum>

export const AiValidationStatusEnum = {
  PENDING: 'pending',
  FAILED: 'failed',
  VALIDATED: 'validated',
  DISCREPANCY: 'discrepancy',
} as const
export type AiValidationStatusType = EnumObjectValues<
  typeof AiValidationStatusEnum
>
export type AiValidationStatusKeysType = EnumObjectKeys<
  typeof AiValidationStatusEnum
>

export const ValidationCompanyModelEnum = {
  Schenker: 'Schenker',
  MRW: 'MRW',
  TXT: 'TXT',
  Sertrans: 'Sertrans',
} as const
export type ValidationCompanyModelType = EnumObjectValues<
  typeof ValidationCompanyModelEnum
>
export type ValidationCompanyModelKeysType = EnumObjectKeys<
  typeof ValidationCompanyModelEnum
>

export const AiValidationResultEnum = {
  OK: 'ok',
  ERROR: 'error',
  MISSING_INFORMATION: 'missing_information',
} as const
export type AiValidationResultType = EnumObjectValues<
  typeof AiValidationResultEnum
>
export type AiValidationResultKeysType = EnumObjectKeys<
  typeof AiValidationResultEnum
>

// domingo primero, en js domingo es el dia 0
export const WeekDayEnum = {
  SUNDAY: 'Domingo',
  MONDAY: 'Lunes',
  TUESDAY: 'Martes',
  WEDNESDAY: 'Miércoles',
  THURSDAY: 'Jueves',
  FRIDAY: 'Viernes',
  SATURDAY: 'Sábado',
} as const
export type WeekDayType = EnumObjectValues<typeof WeekDayEnum>
export type WeekDayKeysType = EnumObjectKeys<typeof WeekDayEnum>

export const WeekDayAbrevEnum = {
  MONDAY: 'Lun',
  TUESDAY: 'Mar',
  WEDNESDAY: 'Mie',
  THURSDAY: 'Jue',
  FRIDAY: 'Vie',
  SATURDAY: 'Sab',
  SUNDAY: 'Dom',
  //continuar con todos los dias de la semana sin usar acentos
} as const
export type WeekDayAbrevType = EnumObjectValues<typeof WeekDayAbrevEnum>
export type WeekDayAbrevKeysType = EnumObjectKeys<typeof WeekDayAbrevEnum>

export const LanguageEnum = {
  SPANISH: 'Español',
  ENGLISH: 'Inglés',
  FRENCH: 'Francés',
  CATALAN: 'Catalán',
  BASQUE: 'Euskera',
  ITALIAN: 'Italiano',
} as const
export type LanguageType = EnumObjectValues<typeof LanguageEnum>
export type LanguageKeysType = EnumObjectKeys<typeof LanguageEnum>

export const CouponStatusEnum = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed',
} as const
export type CouponStatusType = EnumObjectValues<typeof CouponStatusEnum>
export type CouponStatusKeysType = EnumObjectKeys<typeof CouponStatusEnum>

export enum ActionTypeEnum {
  status = 'status',
  create = 'create',
  delete = 'delete',
  cancel = 'cancel',
  edit = 'edit',
  download = 'download',
  enableDisable = 'enableDisable',
  photo = 'photo',
  email = 'email',
  inform = 'inform',
  acceptOffer = 'acceptOffer',
  markAllOffersSeen = 'markAllOffersSeen',
  rate = 'rate',
}
export type ActionType = EnumObjectValues<typeof ActionTypeEnum>
export type ActionKeysType = EnumObjectKeys<typeof ActionTypeEnum>

export const PaymentEnum = {
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
} as const
export type PaymentType = EnumObjectValues<typeof PaymentEnum>
export type PaymentKeysType = EnumObjectKeys<typeof PaymentEnum>

export const CompanyTypeEnum = {
  SHIPPER: 'shipper',
  CARRIER: 'carrier',
} as const
export type CompanyType = EnumObjectValues<typeof CompanyTypeEnum>
export type CompanyKeysType = EnumObjectKeys<typeof CompanyTypeEnum>

export const TransportRequestActionTypeEnum = {
  TEMPLATE: 'template',
  EDIT: 'edit',
  CREATE: 'create',
} as const
export type TransportRequestActionType = EnumObjectValues<
  typeof TransportRequestActionTypeEnum
>
export type TransportRequestActionTypeKeysType = EnumObjectKeys<
  typeof TransportRequestActionTypeEnum
>

export const NotificationEventEnum = {
  AFTER_BUY: 'Después de la compra',
  BEFORE_SESSION: 'Antes de la sesión',
  AFTER_SESSION: 'Después de la sesión',
  RESCHEDULE_SESSION: 'Después de reprogramar sesión',
  CANCEL_SESSION: 'Después de cancelar sesión',
} as const
export type NotificationEventType = EnumObjectValues<
  typeof NotificationEventEnum
>
export type NotificationEventeysType = EnumObjectKeys<
  typeof NotificationEventEnum
>

export const IVAEnum = {
  YES: 'Si',
  NO: 'No',
} as const
export type IVAType = EnumObjectValues<typeof IVAEnum>
export type IVAKeysType = EnumObjectKeys<typeof IVAEnum>

export const IrpfEnum = {
  '7%': 7,
  '15%': 15,
} as const
export type IrpfType = EnumObjectValues<typeof IrpfEnum>
export type IrpfKeysType = EnumObjectKeys<typeof IrpfEnum>

export const NotificationStatusEnum = {
  PENDING: 'pending',
  SENDED: 'sended',
  ERROR: 'error',
} as const
export type NotificationStatusType = EnumObjectValues<
  typeof NotificationStatusEnum
>
export type NotificationStatusKeysType = EnumObjectKeys<
  typeof NotificationStatusEnum
>

export const TruckTypeEnum = {
  FRIDGE: 'Frigo',
  BOXES: 'Box',
  CANVAS: 'Lona',
} as const
export type TruckType = EnumObjectValues<typeof TruckTypeEnum>
export type TruckKeysType = EnumObjectKeys<typeof TruckTypeEnum>

export const TruckTypeSpanishEnum = {
  fridge: 'Frigo',
  boxes: 'Box',
  canvas: 'Lona',
} as const
export type TruckTypeSpanish = EnumObjectValues<typeof TruckTypeSpanishEnum>
export type TruckTypeSpanishKeysType = EnumObjectKeys<
  typeof TruckTypeSpanishEnum
>

export const RequirementsEnum = {
  SOIVRE: 'soivre',
  ADR: 'adr',
  GDP: 'gdp',
  IFS: 'ifs',
  LERN: 'lern',
  TemperaturaControlada: 'TemperaturaControlada',
  Bitemperatura: 'Bitemperatura',
  RGSA: 'rgsa',
} as const
export type RequirementsType = EnumObjectValues<typeof RequirementsEnum>
export type RequirementsKeysType = EnumObjectKeys<typeof RequirementsEnum>

export const ProcessStatusEnum = {
  ACCEPTED: 'Aceptado',
  REJECTED: 'Rechazado',
  EXPIRED: 'Expirado',
  PENDING: 'Pendiente',
} as const

export const AdminTransportTableEnum = {
  SHIPPERS: 'shippers',
  CARRIERS: 'carriers',
} as const

export const EnvEnum = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEV: 'dev',
} as const
export type ModeEnvType = EnumObjectValues<typeof EnvEnum>
export type ModeEnvKeysType = EnumObjectKeys<typeof EnvEnum>

export const HTTPCodeEnum = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  NOT_ALLOWED: 405,
  INTERNAL_ERROR: 500,
} as const

export const InvoiceFieldsEnum = {
  ORIGIN: 'Origen',
  DESTINATION: 'Destino',
  POSTAL_CODE: 'Código postal',
  PRICE: 'Precio',
  WEIGHT: 'Peso',
} as const

export const AlertsTypesEnum = {
  WEIGHT: 'weight',
  VOLUME: 'volume',
  COUNTRIES: 'countries',
} as const
export type AlertsTypesEnumType = EnumObjectValues<typeof AlertsTypesEnum>

export const PricePerWeightTypeEnum = {
  TRANSPORT_COMPANY_PRICE: 'TransportCompany',
  AVERAGE_PRICE: 'Average',
  CHEAPEST_PRICE: 'Cheapest',
} as const

export const ContactEnum = {
  ASSESSOR_TRAACK: 'assessorTraack',
  NATIONAL_PROVIDER: 'nationalProvider',
} as const

export const WeightRangeEnum = {
  '0-500': '0-500',
  '500-1000': '500-1000',
  '1000-2000': '1000-2000',
  '2000-5000': '2000-5000',
  '5000-7500': '5000-7500',
  '7500-10000': '7500-10000',
  '10000-14000': '10000-14000',
  '14000-20000': '14000-20000',
  '20000-24000': '20000-24000',
} as const
export type WeightRangeEnumType = EnumObjectValues<typeof WeightRangeEnum>

export const ControlDocumentStatusEnum = {
  DRAFT: 'draft',
  READY: 'ready',
  GENERATED: 'generated',
} as const
export type ControlDocumentStatusType = EnumObjectValues<
  typeof ControlDocumentStatusEnum
>

export const ProvincesEnum = {
  A_CORUNA: 'A Coruña',
  ALAVA: 'Álava',
  ALBACETE: 'Albacete',
  ALICANTE: 'Alicante',
  ALMERIA: 'Almería',
  ASTURIAS: 'Asturias',
  AVILA: 'Ávila',
  BADAJOZ: 'Badajoz',
  BARCELONA: 'Barcelona',
  BIZKAIA: 'Bizkaia',
  BURGOS: 'Burgos',
  CACERES: 'Cáceres',
  CADIZ: 'Cádiz',
  CANTABRIA: 'Cantabria',
  CASTELLON: 'Castellón',
  CEUTA: 'Ceuta',
  CIUDAD_REAL: 'Ciudad Real',
  CORDOBA: 'Córdoba',
  CUENCA: 'Cuenca',
  GIPUZKOA: 'Gipuzkoa',
  GIRONA: 'Girona',
  GRANADA: 'Granada',
  GUADALAJARA: 'Guadalajara',
  HUELVA: 'Huelva',
  HUESCA: 'Huesca',
  BALEARES_ISLA_MAYOR: 'Islas Baleares',
  BALEARES_ISLA_MENOR: 'Baleares isla menor',
  JAEN: 'Jaén',
  LA_RIOJA: 'La Rioja',
  LAS_PALMAS: 'Las Palmas',
  LEON: 'León',
  LLEIDA: 'Lleida',
  LUGO: 'Lugo',
  MADRID: 'Madrid',
  MALAGA: 'Málaga',
  MELILLA: 'Melilla',
  MURCIA: 'Murcia',
  NAVARRA: 'Navarra',
  OURENSE: 'Ourense',
  PALENCIA: 'Palencia',
  PONTEVEDRA: 'Pontevedra',
  SALAMANCA: 'Salamanca',
  SANTA_CRUZ_DE_TENERIFE: 'Santa Cruz de Tenerife',
  SEGOVIA: 'Segovia',
  SEVILLA: 'Sevilla',
  SORIA: 'Soria',
  TARRAGONA: 'Tarragona',
  TERUEL: 'Teruel',
  TOLEDO: 'Toledo',
  VALENCIA: 'Valencia',
  VALLADOLID: 'Valladolid',
  ZAMORA: 'Zamora',
  ZARAGOZA: 'Zaragoza',
} as const
export type ProvincesEnumType = EnumObjectValues<typeof ProvincesEnum>

export enum IncotermsEnum {
  EXW = 'EXW',
  FOB = 'FOB',
  FCA = 'FCA',
  CFR = 'CFR',
  CIF = 'CIF',
  CPT = 'CPT',
  DAP = 'DAP',
}

export type IncotermsType = EnumObjectValues<typeof IncotermsEnum>
export type IncotermsKeysType = EnumObjectKeys<typeof IncotermsEnum>
